// frontend/src/services/sharedService.js

import axiosInstance from "../axiosInstance";

// Fetch shared survey by token
export const fetchSharedSurvey = async (token) => {
  try {
    const response = await axiosInstance.get(`/surveys/shared/${token}`);
    return response.data.survey;
  } catch (error) {
    console.error(
      "Error fetching shared survey:",
      error.response?.data?.message || error.message
    );
    throw error;
  }
};

// Add a comment to a shared survey
export const addComment = async (token, commentData) => {
  try {
    const response = await axiosInstance.post(
      `/surveys/shared/${token}/comments`,
      commentData
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error adding comment:",
      error.response?.data?.message || error.message
    );
    throw error;
  }
};

// Generate a shared link for a survey
export const generateSharedLink = async (surveyId, expiresIn = "14") => {
  try {
    // Send both surveyId and expiresIn in the POST body
    const response = await axiosInstance.post("/surveys/shared/generate", {
      surveyId,
      expiresIn,
    });
    return response.data; // { message, link, expiresAt }
  } catch (error) {
    console.error(
      "Error generating shared link:",
      error.response?.data?.message || error.message
    );
    throw error;
  }
};

// Fetch shared users for a survey
export const fetchSharedUsers = async (surveyId) => {
  try {
    const response = await axiosInstance.get(
      `/surveys/${surveyId}/shared-users`
    );
    return response.data.sharedUsers;
  } catch (error) {
    console.error(
      "Error fetching shared users:",
      error.response?.data?.message || error.message
    );
    throw error;
  }
};

export const getLatestSharedLink = async (surveyId) => {
  try {
    const response = await axiosInstance.get(`/surveys/${surveyId}/shared-link`);
    return response.data; // e.g. { _id, token, expiresAt, ... }
  } catch (error) {
    console.error(
      "Error fetching the latest shared link:",
      error.response?.data?.message || error.message
    );
    throw error;
  }
};